import { Theme, createStyles } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      "& .MuiToolbar-root": {
        maxWidth: 1366,
      },
      [theme.breakpoints.down(400)]: {
        maxWidth: "100vw",
        margin: 0,
        padding: 0,
      },
      //flexDirection: "column"
    },
    // necessary for content to be below app bar
    toolbar: {
      ...theme.mixins.toolbar,
      minHeight: "65px !important", //'113px !important',
    },
    content: {
      flexGrow: 1,
      padding: "24px 0 24px",
      minHeight: "calc(100vh - 98px)",
      maxWidth: 1366,
      [theme.breakpoints.down(500)]: {
        padding: 15,
        maxWidth: "100%",
      },
    },
  });
